import * as Sentry from "@sentry/react";
import { useEffect } from "react";

import { useCurrentUser } from "@src/hooks/queries/account";

export function useSentryUserSync() {
  const currentUser = useCurrentUser();

  useEffect(() => {
    if (currentUser) {
      Sentry.setUser({ id: currentUser.userId });
    } else {
      Sentry.setUser(null);
    }
  }, [currentUser]);
}
